import { Controller } from "@hotwired/stimulus"

// 값을 고르면 곧바로 폼을 보낸다.
//
// 입고일처럼 "고르는 순간 화면이 바뀌어야 하는" 입력에 붙인다.
// 날짜를 바꾸고도 조회 버튼을 눌러야 반영되면, 바뀐 줄 모르고 다른 날짜의
// 장바구니를 보게 된다 — 발주 사고로 이어질 수 있다.
export default class extends Controller<HTMLElement> {
  submit(): void {
    const form = this.element.closest("form")
    if (!form) return

    // 같은 값으로 다시 고른 경우엔 보내지 않는다.
    const field = this.element as HTMLInputElement
    if (field.dataset.lastValue === field.value) return

    field.dataset.lastValue = field.value
    form.requestSubmit()
  }

  connect(): void {
    const field = this.element as HTMLInputElement
    field.dataset.lastValue = field.value
  }
}
